import React, { useMemo } from 'react';
import {
    CardContainer,
    ContentSection,
    TestimonialTitle,
    TestimonialDescription,
    ProfileSection,
    ProfileImage,
    AvatarPlaceholder,
    ProfileInfo,
    ProfileName,
    ProfileBatch,
} from './styledComponents';

const AVATAR_COLORS = [
    '#EA580C',
    '#4D2BF9',
    '#31B30E',
    '#48A1FA',
    '#AD57F8',
    '#1D4ED8',
];

const getAvatarColor = (name: string): string => {
    if (!name) return AVATAR_COLORS[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % AVATAR_COLORS.length;
    return AVATAR_COLORS[index];
};

const getInitial = (name: string): string => {
    if (!name) return '';
    return name.trim().charAt(0).toUpperCase();
};

export interface TestimonialCardProps {
    name?: string;
    profileImageUrl?: string;
    batch?: string;
    testimonialTitle?: string;
    testimonialDescription?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
    name,
    profileImageUrl,
    batch,
    testimonialTitle,
    testimonialDescription,
}) => {
    const avatarColor = useMemo(() => getAvatarColor(name || ''), [name]);
    const initial = useMemo(() => getInitial(name || ''), [name]);

    return (
        <CardContainer className="testimonial-card">
            <ContentSection>
                {testimonialTitle && (
                    <TestimonialTitle className="testimonial-title">
                        {testimonialTitle}
                    </TestimonialTitle>
                )}
                {testimonialDescription && (
                    <TestimonialDescription className="testimonial-description">
                        {testimonialDescription}
                    </TestimonialDescription>
                )}
            </ContentSection>
            <ProfileSection>
                {profileImageUrl ? (
                    <ProfileImage
                        className="testimonial-profile-image"
                        src={profileImageUrl}
                        alt={name || 'Profile'}
                    />
                ) : (
                    name && (
                        <AvatarPlaceholder
                            className="testimonial-avatar-placeholder"
                            backgroundColor={avatarColor}
                        >
                            {initial}
                        </AvatarPlaceholder>
                    )
                )}
                <ProfileInfo>
                    {name && (
                        <ProfileName className="testimonial-profile-name">{name}</ProfileName>
                    )}
                    {batch && (
                        <ProfileBatch className="testimonial-profile-batch">
                            {batch}
                        </ProfileBatch>
                    )}
                </ProfileInfo>
            </ProfileSection>
        </CardContainer>
    );
};

export default TestimonialCard;
